module.exports = __webpack_public_path__ + "img/logo-sc-navidad.7702c230.png";